<template>
  <v-layout wrap justify-space-between>
    <v-flex xs12>
      <v-text-field
        label="DOI"
        v-model="logEntry['doi']"
        :loading="fetchingDoi"
      >
        <template v-slot:append v-if="true">
          <v-btn 
            fab 
            small 
            color="primary" 
            @click="parseRemoteDoi()" 
            :disabled="crossrefDebouncing > 0"
          >
            <v-icon v-if="crossrefDebouncing === 0">search</v-icon>
            {{crossrefDebouncing === 0 ? "": crossrefDebouncing}}
          </v-btn>
        </template>
      </v-text-field>
    </v-flex>
    <template v-for="component in subcomponents">
      <v-flex
        v-if="component.type !== 'subcomponent'"
        :key="component.id"
        xs12
        :md5="component.type !== 'custom'"
      >
        <AirField
          v-if="component.type !== 'custom'"
          :key="component.id"
          v-model="logEntry[component.id]"
          :component="component"
        />
      </v-flex>
    </template>
  </v-layout>
</template>
<script>
import { SubComponent } from '@/models/ScientificActivity'
import AirField from './AirField'
import crossRefMixin from '@/mixins/crossRef'

export default {
  mixins: [
    crossRefMixin
  ],
  components: {
    AirField
  },
  props: {
    logEntry: { type: Object, default: null }
  },
  data(){
    return {
      fetchingDoi: false
    }
  },
  computed: {
    subcomponents() {
      return SubComponent.query()
        .where('owner', 'journal')
        .get()
    }
  },
  methods: {
    parseRemoteDoi(){
      this.fetchingDoi = true;
      this.getDoiData(this.logEntry['doi'])
      .then(doiData => {
        if(doiData && doiData.title){
          Object.keys(doiData).forEach(
            key => {
              if(doiData[key]){
                this.$set(this.logEntry, key, doiData[key])
              }
            }
          );
        }
        this.fetchingDoi = false;
      });
    }
  }
}
</script>